import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from './en-US.json';
import zhCN from './zh-CN.json';
import { STORAGE_KEYS } from '../constants/storageKeys';

export const SUPPORTED_LOCALES = {
  enUS: 'en-US',
  zhCN: 'zh-CN',
} as const;

export type SupportedLocale =
  (typeof SUPPORTED_LOCALES)[keyof typeof SUPPORTED_LOCALES];

const FALLBACK_LOCALE: SupportedLocale = SUPPORTED_LOCALES.enUS;

const readStoredLocale = (): SupportedLocale => {
  if (typeof window === 'undefined') return FALLBACK_LOCALE;
  const stored = window.localStorage.getItem(STORAGE_KEYS.locale);
  if (stored === SUPPORTED_LOCALES.enUS || stored === SUPPORTED_LOCALES.zhCN) {
    return stored;
  }
  return FALLBACK_LOCALE;
};

void i18n.use(initReactI18next).init({
  resources: {
    [SUPPORTED_LOCALES.enUS]: { translation: enUS },
    [SUPPORTED_LOCALES.zhCN]: { translation: zhCN },
  },
  lng: readStoredLocale(),
  fallbackLng: FALLBACK_LOCALE,
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export const setLocale = (locale: SupportedLocale): Promise<unknown> => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEYS.locale, locale);
  }
  return i18n.changeLanguage(locale);
};

export default i18n;
